import { jsx as _jsx } from "react/jsx-runtime";
import dayjs from "dayjs";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import AtomAccordion from "@/components/AtomAccordion";
import AtomList from "@/components/AtomList";
var RoundInfo = function (_a) {
    var data = _a.data;
    var t = useTranslation().t;
    var roundInfoItems = useCallback(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        return [
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.roundId"),
                value: (_a = data === null || data === void 0 ? void 0 : data.activeGame) === null || _a === void 0 ? void 0 : _a.roundId,
                type: "id",
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.roundStartingDate"),
                value: dayjs(((_b = data === null || data === void 0 ? void 0 : data.activeGame) === null || _b === void 0 ? void 0 : _b.createdAt) * 1000).format("YYYY-MM-DD HH:mm:ss"),
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.bb"),
                value: (_f = (_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.activeGame) === null || _c === void 0 ? void 0 : _c.seats) === null || _d === void 0 ? void 0 : _d.find(function (seat) { var _a, _b; return seat.index === ((_b = (_a = data === null || data === void 0 ? void 0 : data.activeGame) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.bigBlindIndex); })) === null || _e === void 0 ? void 0 : _e.player) === null || _f === void 0 ? void 0 : _f.nickname,
                type: "id",
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.sb"),
                value: (_k = (_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.activeGame) === null || _g === void 0 ? void 0 : _g.seats) === null || _h === void 0 ? void 0 : _h.find(function (seat) { var _a, _b; return seat.index === ((_b = (_a = data === null || data === void 0 ? void 0 : data.activeGame) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.smallBlindIndex); })) === null || _j === void 0 ? void 0 : _j.player) === null || _k === void 0 ? void 0 : _k.nickname,
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.dealer"),
                value: (_p = (_o = (_m = (_l = data === null || data === void 0 ? void 0 : data.activeGame) === null || _l === void 0 ? void 0 : _l.seats) === null || _m === void 0 ? void 0 : _m.find(function (seat) { var _a, _b; return seat.index === ((_b = (_a = data === null || data === void 0 ? void 0 : data.activeGame) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.dealerIndex); })) === null || _o === void 0 ? void 0 : _o.player) === null || _p === void 0 ? void 0 : _p.nickname,
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.roundStatus"),
                value: "N/A",
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.roundPot"),
                value: (_r = (_q = data === null || data === void 0 ? void 0 : data.activeGame) === null || _q === void 0 ? void 0 : _q.state) === null || _r === void 0 ? void 0 : _r.pot,
            },
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.roundWinner"),
                value: "N/A",
            },
        ];
    }, [data, t]);
    return (_jsx(AtomAccordion, { items: [
            {
                label: t("tableManagement.moreInfoDrawer.onlineTableView.roundInfo"),
                key: "roundInfo",
                children: _jsx(AtomList, { items: roundInfoItems() }),
            },
        ] }));
};
export default RoundInfo;
